import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle-2 treatment-count" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(["timer-card disabled", [ _ctx.borderColor, {'unSelectedByDoctor': _ctx.isDisabled} ]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.numberCompleted) + " | " + _toDisplayString(_ctx.numberOfTreatments), 1),
      _createElementVNode("span", {
        class: "text-caption treatment-time text--secondary",
        textContent: _toDisplayString(_ctx.$filters.timestampString(_ctx.timeInTreatment))
      }, null, 8, _hoisted_2),
      _createElementVNode("span", {
        class: _normalizeClass(["text-h5 appointment-time", _ctx.timeTextColor]),
        textContent: _toDisplayString(_ctx.$filters.timestampString(_ctx.timeElapsed))
      }, null, 10, _hoisted_3)
    ]),
    _: 1
  }, 8, ["class"]))
}